<div class="list-completed-mobile" *ngIf="isMobile">
    <div
        class="filter-status-indicator"
        [class.has-active-filters]="isAnyFilterActive"
        style="display: none"
    ></div>
    <nav
        class="list-completed-mobile__header"
        [ngClass]="{ 'full-screen': filterChecked, collapsed: !filterChecked }"
    >
        <div
            class="filterbar list-completed-mobile__filterbar"
            *ngIf="filterChecked"
        >
            <div class="mobile-filter-modal__header">
                <button
                    class="mobile-filter-modal__close"
                    (click)="closeFilter()"
                >
                    <img src="./assets/img/svg/arrow_back.svg" alt="Закрыть" />
                </button>
                <h2>Фильтр</h2>
            </div>
            <div class="mobile-filter-modal__body">
                <div class="mobile-filter-group">
                    <!-- Специальности -->
                    <div class="filter-wrapper">
                        <input
                            type="text"
                            class="custom-input"
                            [(ngModel)]="filters.spec.searchText"
                            (search)="onSearchFilter(filters.spec.mode, $event)"
                            placeholder="Все специальности ({{
                                filters.spec.list.length
                            }} шт.)"
                            [class.active]="isSpecDropdownOpen"
                            (click)="toggleSpecDropdown($event)"
                        />
                        <div *ngIf="isSpecDropdownOpen" class="custom-dropdown">
                            <div
                                class="dropdown-option"
                                (click)="
                                    onChangeFilter(
                                        null,
                                        filters.spec.mode,
                                        $event
                                    )
                                "
                            >
                                Все специальности
                                <span
                                    *ngIf="filters.spec.loading"
                                    class="spinner"
                                ></span>
                            </div>
                            <div
                                *ngFor="
                                    let spec of filters.spec.list
                                        | searchFilter : filters.spec.searchText
                                "
                                class="dropdown-option"
                                (click)="
                                    onChangeFilter(
                                        spec.keyid,
                                        filters.spec.mode,
                                        $event
                                    )
                                "
                            >
                                {{ spec.text }}
                            </div>
                        </div>
                    </div>
                    <!-- Врачи -->
                    <div class="filter-wrapper">
                        <input
                            type="text"
                            class="custom-input"
                            [(ngModel)]="filters.doc.searchText"
                            (search)="onSearchFilter(filters.doc.mode, $event)"
                            placeholder="Все врачи ({{
                                filters.doc.list.length
                            }} шт.)"
                            [class.active]="isDocDropdownOpen"
                            (click)="toggleDocDropdown($event)"
                        />
                        <div *ngIf="isDocDropdownOpen" class="custom-dropdown">
                            <div
                                class="dropdown-option"
                                (click)="
                                    onChangeFilter(
                                        null,
                                        filters.doc.mode,
                                        $event
                                    )
                                "
                            >
                                Все врачи
                                <span
                                    *ngIf="filters.doc.loading"
                                    class="spinner"
                                ></span>
                            </div>
                            <div
                                *ngFor="
                                    let doc of filters.doc.list
                                        | searchFilter : filters.doc.searchText
                                "
                                class="dropdown-option"
                                (click)="
                                    onChangeFilter(
                                        doc.keyid,
                                        filters.doc.mode,
                                        $event
                                    )
                                "
                            >
                                {{ doc.text }}
                            </div>
                        </div>
                    </div>

                    <!-- Филиалы -->
                    <div class="filter-wrapper" *ngIf="showFilials">
                        <input
                            type="text"
                            class="custom-input"
                            [(ngModel)]="filters.dep.searchText"
                            (search)="onSearchFilter(filters.dep.mode, $event)"
                            placeholder="Все филиалы ({{
                                filters.dep.list.length
                            }} шт.)"
                            [class.active]="isDepDropdownOpen"
                            (click)="toggleDepDropdown($event)"
                        />
                        <div *ngIf="isDepDropdownOpen" class="custom-dropdown">
                            <div
                                class="dropdown-option"
                                (click)="
                                    onChangeFilter(
                                        null,
                                        filters.dep.mode,
                                        $event
                                    )
                                "
                            >
                                Все филиалы
                                <span
                                    *ngIf="filters.dep.loading"
                                    class="spinner"
                                ></span>
                            </div>
                            <div
                                *ngFor="
                                    let dep of filters.dep.list
                                        | searchFilter : filters.dep.searchText
                                "
                                class="dropdown-option"
                                (click)="
                                    onChangeFilter(
                                        dep.keyid,
                                        filters.dep.mode,
                                        $event
                                    )
                                "
                            >
                                {{ dep.text }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-completed-mobile__filterbar-bottom">
                    <button (click)="resetFilters()">Сбросить</button>
                    <button (click)="applyFilters()">Применить</button>
                </div>
            </div>
        </div>
    </nav>

    <app-mobile-feed-page-template
        [count-of-pages]="countOfPages"
        [loaded-pages]="loadedPagesMobile"
        [is-loading]="loadingMoreContent"
        [is-feed-empty]="historyPages.length === 0 && loadedPagesMobile === 0"
        [feed-empty-text]="'Посещения не найдены.'"
        [root-url]="'home/history'"
        [view-page]="viewPage"
        [pages]="historyPages"
        [no-more-content-text]="'Посещений больше нет'"
        (load-next-page)="loadMoreHistory(pStart, pEnd)"
        *ngIf="!loading; else pageLoader"
        #content
    >
        <feed-header-period
            header
            [periodText]="periodText"
            (onClick)="showPeriodDialog()"
            [canBeClear]="periodText !== 'Песещения за всё время'"
            (onClear)="btnFilterByDate(null, null)"
        ></feed-header-period>

        <ng-template *ngIf="loading; then showNotRec"></ng-template>

        <section
            page
            [id]="'page' + (pageIndex + 1)"
            class="services-mobile__page"
            *ngFor="let historyPage of historyPages; let pageIndex = index"
        >
            <app-feed-page-anchor
                [is-hidden]="false"
                (intersected)="viewPage = pageIndex + 1"
            >
                Страница {{ pageIndex + 1 }} из {{ countOfPages }}
            </app-feed-page-anchor>

            <ng-container *ngFor="let history of historyPage; let i = index">
                <!-- Карточка для SEMD-посещений -->
                <article
                    *ngIf="history.has_semd && history.has_semd > 0"
                    class="card"
                    (click)="showDetailsDialog(history)"
                >
                    <header class="card__header">
                        <span class="card__day">
                            <!-- <span>&#10036;</span> -->
                            {{ getNameDay(history.dtSort) | titlecase }}
                        </span>
                        <div class="card__date">
                            {{ getDayWithYear(history.dtSort) }}
                            {{ getTime(history.dtSort) }}
                        </div>
                    </header>
                    <div class="card__body">
                        <div class="card__time"></div>
                        <div class="card__spec">
                            <p class="spec">{{ history.spec }}</p>
                            <p class="name">
                                {{ getDoctorName(history.doctor) }}
                            </p>
                        </div>
                    </div>
                    <!-- *ngIf="history.cnt_prot !== 0" -->
                    <div
                        class="btn-pdf"
                        (click)="
                            gotToDownload(
                                history.keyid,
                                history.typehistory,
                                $event,
                                history.has_semd
                            )
                        "
                    >
                        <button class="card-pdf">
                            <img
                                src="./assets/img/svg/pdf-lab1.svg"
                                alt="pdf-lab"
                            />
                        </button>
                    </div>
                    <footer class="card__footer"></footer>
                </article>

                <!-- Обычная карточка (без SEMD) -->
                <article
                    *ngIf="!(history.has_semd && history.has_semd > 0)"
                    class="card"
                    (click)="showDetailsDialog(history)"
                >
                    <header class="card__header">
                        <span class="card__day">
                            {{ getNameDay(history.dtSort) | titlecase }}
                        </span>
                        <div class="card__date">
                            {{ getDayWithYear(history.dtSort) }}
                            {{ getTime(history.dtSort) }}
                        </div>
                    </header>
                    <div class="card__body">
                        <div class="card__time"></div>
                        <div class="card__spec">
                            <p class="spec">{{ history.spec }}</p>
                            <p class="name">
                                {{ getDoctorName(history.doctor) }}
                            </p>
                        </div>
                    </div>
                    <div
                        class="btn-pdf"
                        *ngIf="history.cnt_prot !== 0"
                        (click)="
                            gotToDownload(
                                history.keyid,
                                history.typehistory,
                                $event,
                                history.has_semd
                            )
                        "
                    >
                        <button class="card-pdf">
                            <img
                                src="./assets/img/svg/pdf-lab1.svg"
                                alt="pdf-lab"
                            />
                        </button>
                    </div>
                    <footer class="card__footer"></footer>
                </article>
            </ng-container>
        </section>

        <button fab class="app__calendar-btn" (click)="showPeriodDialog()">
            <mat-icon svgIcon="calendar" class="large-icon"></mat-icon>
            <img src="./assets/img/svg/calendar-icon-new.svg" alt="calendar" />
        </button>
    </app-mobile-feed-page-template>

    <ng-template #pageLoader>
        <div class="loader">
            <loader
                type="page"
                [isFullscreen]="true"
                message="Загрузка списка завершенных посещений"
            ></loader>
        </div>
    </ng-template>
</div>

<div class="list-completed-desktop" *ngIf="!isMobile">
    <nav class="list-completed-desktop__header">
        <div class="filterbar list-completed-desktop__filterbar">
            <div class="filter-wrapper">
                <input
                    type="search"
                    matInput
                    [(ngModel)]="filters.spec.searchText"
                    (search)="onSearchFilter(filters.spec.mode, $event)"
                    [matAutocomplete]="filterSpecRef"
                    class="filter filterbar__filter-spec"
                    placeholder="Все специальности"
                />
                <mat-autocomplete #filterSpecRef class="filter__dropdown">
                    <mat-option
                        class="filter__option"
                        (click)="onChangeFilter(null, filters.spec.mode)"
                        >Все специальности
                        <span
                            class="spinner"
                            *ngIf="filters.spec.loading"
                        ></span
                    ></mat-option>
                    <mat-option
                        *ngFor="
                            let spec of filters.spec.list
                                | searchFilter : filters.spec.searchText
                        "
                        [value]="spec.text"
                        class="filter__option"
                        (click)="onChangeFilter(spec.keyid, filters.spec.mode)"
                        >{{ spec.text }}</mat-option
                    >
                </mat-autocomplete>
            </div>

            <div class="filter-wrapper">
                <input
                    type="search"
                    matInput
                    [(ngModel)]="filters.doc.searchText"
                    (search)="onSearchFilter(filters.doc.mode, $event)"
                    [matAutocomplete]="filterDocRef"
                    class="filter filter-spec filterbar__filter-spec"
                    placeholder="Все врачи"
                />
                <mat-autocomplete #filterDocRef class="filter__dropdown">
                    <mat-option
                        class="filter__option"
                        (click)="onChangeFilter(null, filters.doc.mode)"
                        >Все врачи
                        <span class="spinner" *ngIf="filters.doc.loading"></span
                    ></mat-option>
                    <mat-option
                        *ngFor="
                            let doc of filters.doc.list
                                | searchFilter : filters.doc.searchText
                        "
                        [value]="doc.text"
                        (click)="onChangeFilter(doc.keyid, filters.doc.mode)"
                        class="filter__option"
                        >{{ doc.text }}
                        <span class="spinner" *ngIf="filters.doc.loading"></span
                    ></mat-option>
                </mat-autocomplete>
            </div>

            <div class="filter-wrapper" *ngIf="showFilials">
                <input
                    type="search"
                    matInput
                    [(ngModel)]="filters.dep.searchText"
                    (search)="onSearchFilter(filters.dep.mode, $event)"
                    [matAutocomplete]="filterDepRef"
                    class="filter filter-fil filterbar__filter-spec"
                    placeholder="Все филиалы"
                />
                <mat-autocomplete #filterDepRef class="filter__dropdown">
                    <mat-option
                        class="filter__option"
                        (click)="onChangeFilter(null, filters.dep.mode)"
                        >Все филиалы
                        <span class="spinner" *ngIf="filters.dep.loading"></span
                    ></mat-option>

                    <mat-option
                        *ngFor="
                            let dep of filters.dep.list
                                | searchFilter : filters.dep.searchText
                        "
                        [value]="dep.text"
                        (click)="onChangeFilter(dep.keyid, filters.dep.mode)"
                        class="filter__option"
                        >{{ dep.text }}</mat-option
                    >
                </mat-autocomplete>
            </div>
        </div>
    </nav>

    <div *ngIf="loading" class="loading">
        <loader type="page"> </loader>
    </div>

    <ng-container
        *ngIf="!loading && HistoryEvents.length === 0; else showTable"
    >
        <div class="cls-not-rec">Нет посещений</div>
    </ng-container>

    <ng-template #showTable>
        <!-- [ngStyle]="{ 'grid-template-columns': gridTemplateColumns }" -->
        <section
            #visitsContainer
            class="visits list-completed-desktop__visits"
            (scroll)="onScroll(); $event.preventDefault()"
        >
            <!-- <div
                class="visits__header"
                [ngStyle]="{ 'grid-template-columns': gridTemplateColumns }"
            >
                <div>Дата посещения</div>
                <div>Врач</div>
                <div>Исследование</div>
                <div *ngIf="showFilials">Филиалы</div>
                <div>Отделение</div>
                <div>Повторная запись</div>
                <div>Заключение</div>
            </div> -->
            <div class="visits__body">
                <ng-container
                    *ngFor="let visit of HistoryEvents; let i = index"
                >
                    <div class="yeer" *ngIf="isBlockYeer(i)">
                        {{ getYeer(i) }}
                    </div>
                    <app-visit-card
                        *ngIf="!visit.has_semd || visit.has_semd === 0"
                        class="visits__card"
                        [visit]="visit"
                    >
                    </app-visit-card>

                    <semd-view
                        *ngIf="visit.has_semd && visit.has_semd > 0"
                        class="visits__card"
                        [visit]="visit"
                    >
                    </semd-view>
                    <!-- [gridTemplateColumns]="gridTemplateColumns" -->
                </ng-container>
                <div class="visits__card" *ngIf="loadingMoreContent">
                    Загрузка
                </div>
            </div>
        </section>
        <!-- <div class="cls-ptp-footer visits__footer">
            <app-pagination
                [currentPage]="1"
                [countRecPage]="CountRecPage"
                [countRec]="CountRec"
                textItogo="исследований"
                *ngIf="CountRec > 0"
                (onChangedPage)="changedPage($event)"
            ></app-pagination>
        </div> -->
        <div class="visits__footer" *ngIf="CountRec > 0">
            <div class="visits__footer-content">
                <div class="payments-bottom-loader" *ngIf="loadingMoreContent">
                    <div class="css-spinner"></div>
                    <div class="loader-text">Загрузка посещений...</div>
                </div>
                <span class="visits__footer-text">
                    Записей {{ HistoryEvents.length }} из {{ CountRec }}
                </span>
                <div class="visits__footer-progress">
                    <div
                        class="visits__footer-progress-bar"
                        [style.width.%]="
                            (HistoryEvents.length / CountRec) * 100
                        "
                    ></div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<ng-template #showNotRec>
    <div class="cls-not-rec">Нет посещений</div>
</ng-template>
